export default __webpack_public_path__ + "static/media/PlayPacket.318d53f3.png";